import { collection, doc, getDocs, getDoc, query, where } from 'firebase/firestore';
import { COLLECTIONS, affiliateStatus, pickupStatus, userRoles } from '../configs/Constants';
import { db } from '../configs/Firebase';

const getOverview = async () => {
  const overviewData = {
    totalBookings: 0,
    totalUsers: 0,
    totalExcursions: 0,
    totalAffiliates: 0,
    totalPendingAffilitesApprovals: 0,
    totalApprovedAffiliates: 0,
    totalHotelPickups: 0,
    bookingWithFailedPickupAssignment: 0,
    totalBlogs: 0,
  };

  // Total Bookings
  const bookingQuery = query(collection(db, COLLECTIONS.BOOKINGS));
  const bookingQuerySnapshotSize = (await getDocs(bookingQuery)).size;
  overviewData.totalBookings = bookingQuerySnapshotSize;

  // Total Users - either customer/customerAffiliate
  const usersQuery = query(
    collection(db, COLLECTIONS.USERS),
    where('role', 'in', [userRoles.CUSTOMER, userRoles.CUSTOMERAFFILIATE])
  );
  const usersQuerySnapshotSize = (await getDocs(usersQuery)).size;
  overviewData.totalUsers = usersQuerySnapshotSize;

  // Total Excursions

  const excursionsQueryDocRef = doc(db, COLLECTIONS.EXCURSIONS, 'jsonData');
  const excursionsQueryDocSnap = await getDoc(excursionsQueryDocRef);

  if (excursionsQueryDocSnap.exists()) {
    overviewData.totalExcursions = excursionsQueryDocSnap.data()?.jsonData?.item?.length;
  }

  // Total Affiliates
  const totalAffiliatesQuery = query(collection(db, COLLECTIONS.AFFILIATES));
  const totalAffiliatesQuerySnapshotSize = (await getDocs(totalAffiliatesQuery)).size;
  overviewData.totalAffiliates = totalAffiliatesQuerySnapshotSize;

  // Total Pending Affiliates
  const totalPendingAffiliatesQuery = query(
    collection(db, COLLECTIONS.AFFILIATES),
    where('affiliateStatus', '==', affiliateStatus.PENDING)
  );
  const totalPendingAffiliatesQuerySnapshotSize = (await getDocs(totalPendingAffiliatesQuery)).size;
  overviewData.totalPendingAffilitesApprovals = totalPendingAffiliatesQuerySnapshotSize;

  // Total Approved Affiliates
  const totalApprovedAffiliatesQuery = query(
    collection(db, COLLECTIONS.AFFILIATES),
    where('affiliateStatus', '==', affiliateStatus.APPROVED)
  );
  const totalApprovedAffiliatesQuerySnapshotSize = (await getDocs(totalApprovedAffiliatesQuery))
    .size;
  overviewData.totalApprovedAffiliates = totalApprovedAffiliatesQuerySnapshotSize;

  //  Total Platform Hotel Pickups
  const hotelPickupsQuery = query(collection(db, COLLECTIONS.HOTEL_PICKUPS));
  const hotelPickupsQuerySnapshotSize = (await getDocs(hotelPickupsQuery)).size;
  overviewData.totalHotelPickups = hotelPickupsQuerySnapshotSize;

  // Total  Booking with failed pickup assignment
  const totalbookingWithFailedPickupAssignmentQuery = query(
    collection(db, COLLECTIONS.BOOKINGS),
    where('pickup_status', '!=', pickupStatus.CONFIRMED)
  );
  const totalbookingWithFailedPickupAssignmentQuerySnapshotSize = (
    await getDocs(totalbookingWithFailedPickupAssignmentQuery)
  ).size;
  overviewData.bookingWithFailedPickupAssignment =
    totalbookingWithFailedPickupAssignmentQuerySnapshotSize;

  // Total Blogs
  const blogsQuery = query(collection(db, COLLECTIONS.BLOGS));
  const blogsQuerySnapshotSize = (await getDocs(blogsQuery)).size;
  overviewData.totalBlogs = blogsQuerySnapshotSize;

  return overviewData;
};

// eslint-disable-next-line import/prefer-default-export
export { getOverview };
